import PackAccountItems from "components/assignmentModals/groupTemplatePacksConfirmationModal/packAccountItems/PackAccountItems";
import { type PackMap } from "components/assignmentModals/groupTemplatePacksConfirmationModal/types";
import { type ModalWithStepsStep } from "components/modal/ModalWithSteps";

export interface PacksLicensingModalStepProps extends ModalWithStepsStep {
  packMap: PackMap;
  setIsDisabled: (value: boolean) => void;
}

export const PacksLicensingModalStep: React.FC<PacksLicensingModalStepProps> = ({ packMap, setIsDisabled }) => {
  const infoText = `License quantities for each Pack have been calculated based on the users from the
    existing customer accounts in this template. Quantities may automatically adjust as new users are added.`;

  return <PackAccountItems packMap={packMap} infoText={infoText} setIsDisabled={setIsDisabled} />;
};
